import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import Faq from '../components/faq/Faq';

const FaqPage = () => {
  return (
    <MainLayout>
      <Faq />
    </MainLayout>
  )
}

export default FaqPage
